module.exports = __webpack_public_path__ + "static/media/bmt_bibeo.059e48f8.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/bmt_bibeo.jpg
 ** module id = 670
 ** module chunks = 0
 **/